<script>
import {useSchoolStore} from "@/stores/Training/School.js"
import useSharedData from "@/use/SharedData.js";
import useSharedMethod from "@/use/SharedMethod.js";
import useTools from "@/use/Tools.js";
import {watch} from "vue";
import {useSecurityStore} from "@/stores/Security.js";
import axios from "axios";

export default {
    setup() {
        const {
            total,
            loading,
            filter,
        } = useSharedData();
        
        const {transformFilterValues} = useSharedMethod();
        
        const {$i18n, $router} = useTools();
        
        const schoolStore = useSchoolStore();
        const securityStore = useSecurityStore();
        
        const headers = [
            {
                text: "...",
                align: "left",
                sortable: false,
                value: "action",
                width: "0%"
            },
            {
                text: $i18n.t("common.name"),
                align: "left",
                sortable: true,
                value: "name",
                width: "0%"
            },
            {
                text: $i18n.t("common.phone"),
                align: "left",
                sortable: true,
                value: "phone",
                width: "0%"
            },
            {
                text: $i18n.t("common.email"),
                align: "left",
                sortable: true,
                value: "email",
            },
            {
                text: $i18n.t("common.address"),
                align: "left",
                sortable: true,
                value: "address",
            },
        ];
        
        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_TRAINING_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'schools.edit', params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['UPDATE_TRAINING_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'schools.delete', params: {id: item.id}})
                },
            },
        ];
        
        function findAll() {
            loading.value = true;
            axios.get('/schools', {params: transformFilterValues(filter.value)}).then((response) => {
                schoolStore.setSchools(response.data);
                total.value = response.data.length;
            }).finally(() => {
                loading.value = false;
            });
        }
        
        watch(() => filter.value, () => {
            findAll();
        }, {deep: true, immediate: true});
        
        function view(item) {
            $router.push({name: "schools.view", params: {id: item.id}});
        }
        
        return {
            schoolStore,
            securityStore,
            headers,
            actions,
            total,
            loading,
            filter,
            view,
            findAll,
        };
    },
};
</script>

<template>
    <div>
        <w-app
            :title="$t('module.training_school')"
            :total="total"
        >
            
            <template v-slot:rightToolbar>
                <w-btn-reload
                    :loading="loading"
                    @press="findAll"
                />
                <w-btn-add
                    :show="securityStore.authorities['UPDATE_TRAINING_PARAM']"
                    @press="$router.push({ name: 'schools.add' })"
                />
            </template>
            
            <template v-slot:content>
                <v-container fluid>
                    <v-row dense>
                        <v-col cols="3">
                            <w-text-field
                                v-model="filter.name"
                                :label="$t('common.name')"
                            />
                        </v-col>
                        <v-col cols="3">
                            <w-state-autocomplete
                                v-model="filter.stateId"
                                :label="$t('common.country_state')"
                            />
                        </v-col>
                        <v-col cols="3">
                            <w-city-autocomplete
                                v-model="filter.cityId"
                                item-value="id"
                                :state-id="filter.stateId"
                                :label="$t('common.country_city')"
                            />
                        </v-col>
                    </v-row>
                </v-container>
                <w-data-table
                    :headers="headers"
                    :actions="actions"
                    :items="schoolStore.schools"
                    :total="total"
                    :loading="loading"
                    sort-by="name"
                    @rowDbClick="view"
                >
                    <template v-slot:[`item.name`]="{ item }">
                        <w-inline-text bold  :text="item.name"/>
                    </template>
                    <template v-slot:[`item.phone`]="{ item }">
                        <w-inline-text :text="item.phone"/>
                    </template>
                    <template v-slot:[`item.email`]="{ item }">
                        <w-inline-text :text="item.email"/>
                    </template>
                    <template v-slot:[`item.address`]="{ item }">
                        <w-inline-text :text="item.address"/>
                    </template>
                </w-data-table>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>
